import { configureStore } from "@reduxjs/toolkit";
import lessonsReducer from "./features/lessons/lessonsSlice";

export const store = configureStore({
  reducer: {
    lessons: lessonsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
